/* Cart incentive progress — see snippets/om-cart-progress.liquid.
   Standalone so the core script stays untouched. */
(function () {
  var bars = document.querySelectorAll('[data-cart-progress]');
  if (!bars.length) return;

  var fmt = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  function paint(cart) {
    bars.forEach(function (bar) {
      var msg  = bar.querySelector('[data-cp-msg]');
      var fill = bar.querySelector('[data-cp-fill]');
      var shipMin = parseFloat(bar.getAttribute('data-ship-min')) * 100;
      var qtyMin  = parseInt(bar.getAttribute('data-qty-min'), 10);
      var qtyPct  = bar.getAttribute('data-qty-pct');

      var count = cart.item_count || 0;
      if (!count) { bar.hidden = true; return; }
      bar.hidden = false;

      var total  = cart.total_price || 0;
      var toShip = shipMin - total;
      var toQty  = qtyMin - count;
      var text, pct;

      if (toQty > 0) {
        text = 'Add ' + toQty + ' more ' + (toQty === 1 ? 'formulation' : 'formulations') +
               ' and save ' + qtyPct + '%';
        pct  = (count / qtyMin) * 100;
      } else if (toShip > 0) {
        text = fmt(toShip) + ' from free shipping · ' + qtyPct + '% saving applied';
        pct  = (total / shipMin) * 100;
      } else {
        text = qtyPct + '% saving and free shipping applied';
        pct  = 100;
      }

      msg.textContent = text;
      fill.style.width = Math.max(4, Math.min(100, pct)) + '%';
      bar.setAttribute('data-complete', pct >= 100 ? 'true' : 'false');
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {});
  }

  refresh();

  var counter = document.querySelector('[data-cart-count]');
  if (counter && 'MutationObserver' in window) {
    new MutationObserver(refresh).observe(counter, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener('omnivia:cart:updated', refresh);
}());
